import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'

// axios.defaults.baseURL = 'https://api.pse.gbitsrv.pl/api/survey'
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'https://api.budowalinii.pl/api/survey'
Vue.use(VueAxios, axios)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
